@file:OptIn(ExperimentalWasmJsInterop::class)

package fr.arcplex.network.cache

@JsFun("(key) => localStorage.getItem(key)")
external fun lsGet(key: String): String?

@JsFun("(key, value) => window.localStorage.setItem(key, value)")
external fun lsSet(key: String, value: String)

@JsFun("(key) => window.localStorage.removeItem(key)")
external fun lsRemove(key: String)

@JsFun("() => localStorage.length")
external fun lsLength(): Int

@JsFun("(index) => localStorage.key(index)")
external fun lsKey(index: Int): String?

@JsFun("() => Date.now()")
external fun jsDateNow(): Double

actual fun createCacheStorage(namespace: String, kind: StorageKind): CacheStorage =
    LocalStorageCacheStorage("soonerkmm_" + namespace.replace('-', '_') + "_")

actual fun currentTimeMillis(): Long = jsDateNow().toLong()

class LocalStorageCacheStorage(private val prefix: String) : CacheStorage {
    override suspend fun read(key: String): String? = try {
        lsGet(prefix + key)
    } catch (e: Exception) {
        null
    }

    override suspend fun write(key: String, value: String) {
        try {
            lsSet(prefix + key, value)
        } catch (e: Exception) {
        }
    }

    override suspend fun delete(key: String) {
        try {
            lsRemove(prefix + key)
        } catch (e: Exception) {
        }
    }

    override suspend fun listKeys(): List<String> = try {
        val size = lsLength()
        (0 until size).mapNotNull { i ->
            lsKey(i)
                ?.takeIf { it.startsWith(prefix) }
                ?.removePrefix(prefix)
        }
    } catch (e: Exception) {
        emptyList()
    }
}
